import { c as _c } from "react/compiler-runtime";
import { useSphereDialog } from "@components/common/dialog/sphere-dialog-provider";
import { SphereIconButton } from "@components/common/sphere-icon-button";
import { ACTION_BTN_SIZE, ACTION_ICON_SIZE } from "@styles/common-styles";
import { SphereShareLink } from "@components/common/sphere-share-link";
import { ShareLinkIcon, Tooltip } from "@flat-ui";
import { useSharedMarkupActions } from "@hooks/project-markups/use-shared-markups-actions";
import { AnnotationEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { useCallback } from "react";

/**
 * Dialog provider props to use for the share annotation dialog.
 */
export const SHARE_ANNOTATION_DIALOG_PROVIDER_PROPS = {
  title: "Share annotation",
  isHideConfirm: true,
  isHideCancel: true
};

/**
 * Component that represents a share icon for a specific markup,
 * allowing users to share a link to the markup via a dialog.
 * Renders a share icon that, when clicked, displays a dialog with the link
 * to the currently viewed markup.
 *
 * @param markup The properties of the current markup
 * @returns A JSX element representing the markup share icon, wrapped
 * in a tooltip component to display "Share annotation" when hovering over the icon.
 */
export function MarkupActionShareMarkup(t0) {
  const $ = _c(8);
  const {
    markup
  } = t0;
  const {
    createDialog
  } = useSphereDialog();
  const {
    trackEvent
  } = useTrackEvent();
  let t1;
  if ($[0] !== markup) {
    t1 = {
      markup
    };
    $[0] = markup;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    markupHref
  } = useSharedMarkupActions(t1);
  let t2;
  if ($[2] !== createDialog || $[3] !== markupHref || $[4] !== trackEvent) {
    t2 = event => {
      event.preventDefault();
      event.stopPropagation();
      trackEvent({
        name: AnnotationEvents.shareAnnotation,
        props: {
          location: "markup-sidepanel"
        }
      });
      if (!markupHref) {
        return;
      }
      createDialog(SHARE_ANNOTATION_DIALOG_PROVIDER_PROPS, <SphereShareLink title="Annotation link" url={markupHref} copyLogEventParams={{
        name: AnnotationEvents.copyShareAnnotationLink,
        props: {
          location: "markup-sidepanel"
        }
      }} />);
    };
    $[2] = createDialog;
    $[3] = markupHref;
    $[4] = trackEvent;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const onShareMarkup = t2;
  if (!markupHref) {
    return null;
  }
  let t3;
  if ($[6] !== onShareMarkup) {
    t3 = <Tooltip component="div" title="Share annotation"><SphereIconButton buttonSize={ACTION_BTN_SIZE} iconSize={ACTION_ICON_SIZE} component={ShareLinkIcon} onClick={onShareMarkup} /></Tooltip>;
    $[6] = onShareMarkup;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}